import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Stack, Typography } from "@mui/material";
import StatementForm from "./StatementForm";
import "./styles.scss";

type BooksDrawerProps = {
  setOpen: Function;
};

const StatementsDrawer = ({ setOpen }: BooksDrawerProps) => {

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const drawerComp = (
    <Stack>
      <Box className="drawer-header" role="presentation">
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          fontWeight={700}
        >
          Transaction Detail
        </Typography>
      </Box>
      <StatementForm handleDrawerClose={handleDrawerClose} />
    </Stack>
  );

  return (
    <div className="transaction-drawer">
      <Drawer
        anchor="right"
        variant="temporary"
        open={true}
      >
        {drawerComp}
      </Drawer>
    </div>
  );
};

export default StatementsDrawer;
